import React from 'react';
import { Stack } from '@mui/material';
import { CssTextField } from 'pages/reference-implementation/components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload, isBudgetCodeValid } from 'pages/reference-implementation/provisioning/RI003/store';
import { InputLabel } from 'pages/reference-implementation/components/input-label';
import HelpImg from 'pages/provisioning/_components/helpImg';

export const BudgetCode = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [, setBudgetCodeValid] = useRecoilState(isBudgetCodeValid);
    const [hPrefixError, setHPrefixError] = React.useState(false);

    const setBudgetCode = (budgetCode = null) => {
        const hasHPrefix = /^[Hh]-/.test(budgetCode);
        setHPrefixError(hasHPrefix);
        setBudgetCodeValid(!hasHPrefix);
        setOrder({
            ...order,
            budgetCode,
        });
    };

    React.useEffect(() => {
        if (order?.budgetCode) {
            const hasHPrefix = /^[Hh]-/.test(order.budgetCode);
            setHPrefixError(hasHPrefix);
            setBudgetCodeValid(!hasHPrefix);
        }
    }, [order?.budgetCode]);

    const validateInput = () => {
        if ((isTouched && order?.isTouched && !order?.budgetCode) || hPrefixError) {
            return 'validate';
        }
        return '';
    };

    React.useEffect(() => {
        if (!order?.budgetCode && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.budgetCode, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} alignItems="flex-start" data-testid="h-code-box">
            <CssTextField
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                autoComplete="off"
                label={<InputLabel label="Cost Center, GL Account or PEP Element" isRequired />}
                error={hPrefixError}
                helperText={
                    hPrefixError ? (
                        <span
                            style={{
                                display: 'block',
                                textAlign: 'left',
                            }}
                        >
                            {
                                "The 'H-' prefix is not allowed. Please enter the value without the 'H-' prefix. For more details, refer to the tooltip information or contact us at "
                            }
                            <a
                                href="mailto:dl-globalcmpoperations@pepsico.com"
                                style={{
                                    whiteSpace: 'nowrap',
                                    wordBreak: 'normal',
                                }}
                            >
                                dl-globalcmpoperations@pepsico.com
                            </a>
                        </span>
                    ) : null
                }
                value={order?.budgetCode || ''}
                onChange={(e) => setBudgetCode(e.target.value)}
                className={validateInput()}
            />
            <Stack sx={{ pt: 1 }}>
                <HelpImg title="The 'H-' based cost centers/budget codes have been deprecated. Please use the latest budget codes for the project where you are deploying resources." />
            </Stack>
        </Stack>
    );
};

export default BudgetCode;
